import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const host = process.env.REACT_APP_API_HOST;
const req = `${host}/${apiConstants.QUOTE_REQUIREMENTS}`;
const orders = `${host}/${apiConstants.ORDERS}`;
const data = async (p) => (await p).data;

// Staff side: the requirements queue (internal view) and orders.
export const listStaffRequirements = (params = {}) => data(axios.get(req, { params }));
export const getStaffRequirement = (number) => data(axios.get(`${req}/${number}`));
// Requirements raised in the CRM that the app has not seen - visits, mostly.
export const importRequirementsFromCrm = () => data(axios.post(`${req}/import-from-crm`, {}));
// Which single vendor could supply the whole requirement, beside the
// cheapest split the line costs already assume. Read-only.
export const getRequirementSourcing = (number) => data(axios.get(`${req}/${number}/sourcing`));
export const resolveLine = (number, lineId, body) => axios.post(`${req}/${number}/lines/${lineId}/resolve`, body);
export const publishQuote = (number) => axios.post(`${req}/${number}/cost`, {});
export const addStaffComment = (number, text, visibility) => axios.post(`${req}/${number}/comments`, { text, visibility });
export const setCustomerStatus = (number, customerStatus) => axios.put(`${req}/${number}/customer-status`, { customerStatus });
// Staff-only: who a stuck requirement is waiting on; empty clears it.
export const setWaitingOn = (number, waitingOn) => axios.put(`${req}/${number}/waiting-on`, { waitingOn: waitingOn || null });

export const listStaffOrders = (params = {}) => data(axios.get(orders, { params }));
export const getStaffOrder = (id) => data(axios.get(`${orders}/${id}`));
export const setOrderStatus = (id, status) => axios.put(`${orders}/${id}/status`, { status });
export const addDispatch = (id, form) => axios.post(`${orders}/${id}/dispatches`, form); // FormData
